<template>
    <div>
        <Header></Header>
        <UserLogin></UserLogin>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Home/Header.vue';
    import UserLogin from '@/components/User/UserLogin.vue';
    import Footer from '@/components/Home/Footer.vue';

    import "../assets/css/stylea.css";
    import "../assets/css/main1.css";

    export default {
        name: 'Login',
        data(){
            return{
                doctor_id:0
            }
        },
        components: {
            Header,
            UserLogin,
            Footer,
        },
        mounted(){

        }
    }
</script>
